import styled from '@emotion/styled';
import {colors} from '@styles/colors';
import {fontWeight, mq} from '@styles/helpers';
import {absoluteCenter} from '@styles/reusable';
import Tooltip from '@components/Tooltips/Tooltip';
import {Devices} from '@styles/tokens';


export const StyledTooltip = styled(Tooltip)`
  position: absolute;
  bottom: 5vh;
  left: 7.04vw;

  ${mq(Devices.tablet)} {
    left: var(--padding);
  }
`;

export const Profile = styled.button<{ active: boolean, topMenu: boolean }>`
  /* background-color: yellow; */
  position: relative;
  min-height: 55px;
  min-width: 200px;
  z-index: 6;
  cursor: default;
  margin-top:auto;

  ${mq(Devices.tablet)} {
    min-height: 42px;
  }

  ${mq(Devices.mobile)} {
    margin-left: unset;
  }
`;


export const Container = styled.div<{topMenu:boolean}>`
  position: relative;
  display: ${props => props.topMenu?"flex": "block"} !important;
  width: 100%;
  height: 100%;
  align-items: center;
`;

export const TextContainer = styled.div<{topMenu:boolean}>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* width: 100%; */
  height: 100%;
  color: ${colors.white};
  margin-left: 15px;
  text-align: ${props => props.topMenu?"right": "left"};
`;

export const PicContainer = styled.div<{show: boolean}>`
  position: relative;
  display: ${props => props.show ?"block": "none"};
  border-radius: 50%;
  height: 55px;
  aspect-ratio: 1 / 1;
  background-color: ${colors.white};
  overflow: hidden;
  box-shadow: 0 0 2px 0 rgba(0,0,0,0.4);

  ${mq(Devices.tablet)} {
    width: 42px;
    height: 42px;
  }
`;

export const Name = styled.h3<{topMenu:boolean}>`
  color:${props => props.topMenu ? props.theme.colors.mainTextColor: "#fff"};
  font-size: 16px;
  font-weight: ${fontWeight.semiBold};
  white-space: nowrap;

  ${mq(Devices.tablet)} {
    font-size: 14px;
  }
`;

export const AccountType = styled.p<{topMenu:boolean}>`
  font-size: 12px;
  color: ${props => props.topMenu ? props.theme.colors.mainTextColor: "#fff"};
`;

export const Placeholder = styled.p`
  font-size: 14px;
  font-weight: ${fontWeight.semiBold};
`;


export const PopupArrow = styled.div<{show:boolean}>`
display: ${props => props.show?"block" : "none"};
  position: absolute;
  top:18px;
  right:0;
  width:20px;
  height:20px;
  transform: scaleY(-1);
  transition: transform 0.1s ease-in-out;

  svg{
    path{
      fill:#fff;
    }
  }

  ${Profile}:hover & {
    transform: scaleY(1);
  }
`;

export const UserPopup = styled.div<{show:boolean}>`
  opacity: 0;
  display:none;
  width:auto;
  min-width: 100%;
  position: absolute;
  bottom:55px;
  padding-bottom: 15px;
  transition: opacity 0.2s ease-in-out;

  ${Profile}:hover & {
    opacity:1;
    display: ${props => props.show?"block" : "none"};
    pointer-events: all;
  }
  
`;

export const PopupWhiteSpace = styled.div`
  width:100%;
  background:#fff;
  box-shadow: 0 0 4px 1px rgba(0,0,0,0.30);
  border-radius: 5px;
  pointer-events: all;
  padding-top:10px;
  padding-bottom:1px;
`;

export const UserContainer = styled.div<{topMenu:boolean}>`
  position: relative;
  display: ${props => props.topMenu?"flex": "block"} !important;
  width: 100%;
  height: 55px;
  align-items: center;
  color:#fff;
  cursor:pointer;
  pointer-events: all;
  margin:0 0 10px 0;
  padding:0 10px;

  :hover{
    background:#d6d6d6;
  }

`;

export const UserTextContainer = styled(TextContainer)`
  color:#000 !important;
  
`;

export const UserName = styled(Name)`
  color:#000 !important;
`;

export const UserAccountType = styled(AccountType)`
  color:#000 !important;
`;